import React from 'react';
import DropdownComp from '../dropdown/dropdown';
import { formatDate, parseDate } from '../../utils/date';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import { withTranslation } from "react-i18next";
export default withTranslation()(class TimeDropdownComp extends React.PureComponent {

    constructor(props) {
        super(props);
        this.showStartDatePicker = this.showStartDatePicker.bind(this);
        this.showEndDatePicker = this.showEndDatePicker.bind(this);
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
    }

    showStartDatePicker() {
		this.endDatePicker.hideDayPicker();
		this.startDatePicker.showDayPicker();
	}

	showEndDatePicker() {
		this.startDatePicker.hideDayPicker();
		this.endDatePicker.showDayPicker();
	}

    handleStartDateChange(selectedDay, modifiers, dayPickerInput) {
		//console.log('handleStartDateChange', selectedDay);
		let dateObj = {};
        dateObj.start_date = moment(selectedDay).format("M/DD/YYYY");
        const filter = this.props.filter;
		if (
			typeof dateObj.start_date !== "undefined" &&
			filter.end_date &&
			moment(dateObj.start_date).diff(moment(filter.end_date)) >= 0
		) {
			dateObj.end_date = "";
        }
		this.props.updateFilters(dateObj);
	}

	handleEndDateChange(selectedDay, modifiers, dayPickerInput) {
		//console.log('handleEndDateChange', selectedDay);
		let end_date = moment(selectedDay).format("M/DD/YYYY");
		this.props.updateFilters({ end_date });
    }
    
    render() {
        const { t } = this.props;
        const props = this.props;
        let {start_date, end_date, time} = props.filter;

        let timeStartDateProps = { dayPickerProps: {} };
		let timeEndDateProps = { dayPickerProps: {} };
		let timeStartDate = start_date
			? moment(start_date).format("MMM DD, YYYY")
			: "";
		let timeEndDate = end_date ? moment(end_date).format("MMM DD, YYYY") : "";
		let selectedStartDateString = undefined;
		if (start_date) {
			let startDateString = moment(start_date).toDate();
			selectedStartDateString = startDateString;
			timeEndDateProps.dayPickerProps = {
				month: startDateString,
				fromMonth: startDateString, 
				disabledDays: {
					before: startDateString
				}
			};
			timeStartDateProps.dayPickerProps.month = selectedStartDateString;
		}
		let selectedDateString = undefined;
		if (end_date) {
			selectedDateString = moment(end_date).toDate();
			timeEndDateProps.dayPickerProps.month = selectedDateString;
		}
		timeStartDateProps.dayPickerProps.selectedDays = selectedStartDateString;
		timeEndDateProps.dayPickerProps.selectedDays = selectedDateString;
        return (
            <div className='filter-time-wrapper'>
                {
                    time != 5 ?
                        <DropdownComp
                            key='dropdown_time'
                            defaultValue={props.filter.time}
                            options={props.filterOptions}
                            onChange={props.onChangeDateFilters}
                            wrapperClass='single-row time-dropdown-wrapper'
                            appendId={props.key}
                        />
                    :
                    <div className="show-custom-datepicker">
                        <div className="aEdivWidth600 marginTop30">
                            <div className="inLineBlk aEStartDate aEStartDates ">
                                {t('Start date ')}
                            </div>
                            <div className="inLineBlk aEEndDate time-end-date">
                                {t('End date')} 
                            </div>
                        </div>
                        <div className="aEdivWidth600">
                            <div className="inLineBlk aEStartDate left dateShowPopup" onClick={() => this.showStartDatePicker()}>
                                <div
                                    className="aEStartIcon dateShowPopup"
                                />
                                <DayPickerInput
                                    ref={el => (this.startDatePicker = el)}
                                    format="MMM DD, YYYY"
                                    value={timeStartDate}
                                    formatDate={formatDate}
                                    parseDate={parseDate}
                                    placeholder=""
                                    inputProps={{
                                        id: "time_start",
                                        name: "time_start",
                                        type: "text",
                                        autoComplete: 'off'
                                    }}
                                    {...timeStartDateProps}
                                    keepFocus={false}
                                    onDayChange={this.handleStartDateChange}
                                />
                            </div>
                            <div className="inLineBlk left goalTotext">{t('to')}</div>
                            <div className="inLineBlk aEEndDate left dateShowPopup" onClick={() => this.showEndDatePicker()}>
                                <div
                                    className="aEStartIcon dateShowPopup"
                                />
                                <DayPickerInput
                                    ref={el => (this.endDatePicker = el)}
                                    inputProps={{
                                        id: "time_end",
                                        name: "time_end",
                                        type: "text",
                                        autoComplete: 'off'
                                    }}
                                    format="MMM DD, YYYY"
                                    value={timeEndDate}
                                    formatDate={formatDate}
                                    parseDate={parseDate}
                                    placeholder=""
                                    {...timeEndDateProps}
                                    keepFocus={false}
                                    onDayChange={this.handleEndDateChange}
                                />
                            </div>
                            <div className="clear" />
                        </div>
                    </div>
                }
                <div className='clear'></div>
            </div>
        );
    }
})